import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Icon from 'material-ui/svg-icons/file/cloud-download'
import Popper from '@material-ui/core/Popper'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import MenuItem from '@material-ui/core/MenuItem'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import MenuList from '@material-ui/core/MenuList'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import FileDownload from 'js-file-download'
import classNames from 'classnames'
import * as API from '../api'

const styles = {
  downloadButton: {
    position: 'relative'
  },
  popper: {
    zIndex: 999999
  },
  downloadButtonProgress: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    margin: 'auto'
  }
}

class ExportButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      anchorEl: null,
      dropdownOpen: false,
      options: [],
      loading: false
    }
  }
  setOpen = dropdownOpen => {
    if (dropdownOpen) {
      this.setState({ dropdownOpen })
    } else {
      this.setState({ dropdownOpen, options: [] })
    }
  }
  getContentAvaibleExports = () => {
    return API.content.getContentAvaibleExports(this.props.contentId).then(response => {
      this.setState({ options: response.data })
    })
  }
  makeDownload = ({ type, mime }) => {
    const { contentId } = this.props
    const { loading } = this.state
    if (loading) return
    this.setState({ loading: true, dropdownOpen: false })
    API.content
      .downloadContent({ id: contentId, type })
      .then(response => {
        FileDownload(response.data, `${contentId}-${Date.now()}.${type}`, mime)
      })
      .finally(() => {
        this.setState({ loading: false })
      })
  }
  handleToggle = event => {
    const { currentTarget } = event
    const { loading } = this.state
    if (loading) return
    this.setState({ loading: true })
    this.getContentAvaibleExports()
      .then(() => {
        this.setState(state => ({
          anchorEl: currentTarget,
          dropdownOpen: !state.dropdownOpen,
          loading: false
        }))
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }
  handleClose = event => {
    const { anchorEl } = this.state
    if (anchorEl && anchorEl.current && anchorEl.current.contains(event.target)) {
      return
    }

    this.setOpen(false)
  }

  render() {
    const { handleClose, makeDownload } = this
    const { classes } = this.props
    const { dropdownOpen, options, anchorEl, loading } = this.state
    const id = dropdownOpen ? `export-popper-${this.props.contentId}` : null

    return (
      <React.Fragment>
        <IconButton
          aria-describedby={id}
          onClick={this.handleToggle}
          className={classNames(classes.downloadButton)}
        >
          <Icon />
          {!!loading && <CircularProgress className={classNames(classes.downloadButtonProgress)} />}
        </IconButton>
        <Popper
          className={classes.popper}
          id={id}
          open={dropdownOpen}
          anchorEl={anchorEl}
          transition
        >
          {({ TransitionProps }) => (
            <Grow {...TransitionProps} timeout={350}>
              <Paper id="menu-list-grow">
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList>
                    {options.map((option, index) => (
                      <MenuItem
                        key={option.type}
                        onClick={event => makeDownload({ type: option.type, mime: option.mime })}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </React.Fragment>
    )
  }
}

export default withStyles(styles)(ExportButton)



// WEBPACK FOOTER //
// ./src/components/ExportButton.js